import { useContent } from "@/context/ContentContext";
import { resolveImage } from "@/lib/api";
import { Factory, Award, Users, Globe, ShieldCheck } from "lucide-react";

const ICON_MAP = { Factory, Award, Users, Globe, ShieldCheck };

export default function About() {
  const { content } = useContent();
  const a = content?.about || {};
  const brand = content?.brand || {};
  const heroImg = content?.page_images?.about_hero;
  const paragraphs = (a.body || "").split(/\n{2,}/).filter(Boolean);

  return (
    <div className="max-w-7xl mx-auto px-4 py-16 animate-tmf-fade">
      <div className="border-b border-slate-200 pb-6 mb-12">
        <div className="text-[10px] font-mono-tmf uppercase tracking-widest text-tmf-blue mb-2">{a.eyebrow}</div>
        <h1 className="font-display font-black text-4xl md:text-6xl uppercase tracking-tight text-tmf-navy">{a.title}</h1>
      </div>

      {heroImg && (
        <div className="aspect-[16/6] w-full overflow-hidden border border-slate-200 mb-12">
          <img src={resolveImage(heroImg)} alt="About TMF" className="w-full h-full object-cover" />
        </div>
      )}

      <div className="grid lg:grid-cols-12 gap-8 mb-16">
        <div className="lg:col-span-7 space-y-6 text-slate-700 leading-relaxed">
          <p className="text-xl text-tmf-navy font-display">
            <strong>{a.intro}</strong>
          </p>
          {paragraphs.map((p, i) => <p key={`p-${i}-${p.slice(0, 24)}`}>{p}</p>)}
        </div>
        <div className="lg:col-span-5 space-y-3">
          <div className="border border-tmf-navy p-5">
            <div className="text-[10px] font-mono-tmf uppercase tracking-widest text-tmf-blue mb-1">Company</div>
            <div className="font-display font-bold">{brand.company || "Silver Sure Vending Solutions LLP"}</div>
          </div>
          <div className="border border-tmf-navy p-5">
            <div className="text-[10px] font-mono-tmf uppercase tracking-widest text-tmf-blue mb-1">Brand</div>
            <div className="font-display font-bold">{brand.name} {brand.tagline}</div>
          </div>
          <div className="border border-tmf-navy p-5">
            <div className="text-[10px] font-mono-tmf uppercase tracking-widest text-tmf-blue mb-1">Certifications</div>
            <div className="font-display font-bold">GeM OEM · ISO 13485 · 9001 · CE</div>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-4 gap-px bg-slate-200">
        {(a.stats || []).map((s, i) => {
          const Icon = [Factory, Users, Award, Globe][i % 4];
          return (
            <div key={s.l} className="bg-white p-8">
              <Icon size={28} className="text-tmf-blue mb-4" />
              <div className="font-display font-black text-3xl text-tmf-navy">{s.n}</div>
              <div className="text-[10px] font-mono-tmf uppercase tracking-widest text-slate-500 mt-1">{s.l}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
